export default __webpack_public_path__ + "static/media/dot-simple-background.3f060526.svg";